
document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-vacancy-apply]');
  if (!btn) return;

  const field = document.querySelector('[data-vacancy-field]');
  if (field) field.value = btn.dataset.vacancyApply;

  const form = document.querySelector('#vacancy-form');
  if (form) form.open = true;

  form?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  document.querySelector('#vacancy-form input[name="contact[name]"]')?.focus({ preventScroll: true });
});
